module.exports = __webpack_public_path__ + "img/open-apis-benefits.091def69.svg";